export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: 'a807cf8', dateTime: 1779301040091 };